<script lang="ts">
	import EventInfo from './EventInfo.svelte';
	import FighterDetails from './FighterDetails.svelte';
	import type { BoutInfo } from '../types';
	import { fetchBout } from '../api/xapi/fetch';
	import { sample } from '../utils';

	const extractBoutId = (location: Location): string | null => {
		if (import.meta.env.DEV) {
			return sample([
				'2d64924a-da6e-4ef2-8092-40fc2f1a7e9f',
				'70534477-d890-44b9-b5b9-1601fbfc337e'
			]);
		}

		const match = location.pathname.match(/\/bout\/([-A-Za-z0-9]+)/);
		return match !== null ? match[1] : null;
	};

	let bout: BoutInfo;
	const boutID = extractBoutId(window.location);

	$: fetchBout(boutID).then((data) => (bout = data));
</script>

<svelte:head>
	{#if bout}
		<title
			>Bout Stats - {bout?.attributes?.blueCorner.displayName} vs. {bout?.attributes?.redCorner
				.displayName}</title
		>
	{/if}
</svelte:head>

<section>
	{#if boutID === null}
		<h1>Invalid Bout ID</h1>
	{:else if bout}
		<EventInfo event={bout.event} />

		<FighterDetails {bout} />
	{:else}
		<p>loading...</p>
	{/if}
</section>
